export { GolfTeeTimesTemplate } from './GolfTeeTimesTemplate';
export type {
  GolfTeeTimeOption,
  GolfTeeTimesTemplateLabels,
  GolfTeeTimesTemplateProps,
} from './GolfTeeTimesTemplate.types';
